// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"s_bL ml-3","matrix-table--pad4":"s_bM ml-5","matrix-table__title":"s_bN","matrix-table__true":"s_bP","matrix-table__false":"s_bQ"};